import { ReactNode } from "react";

import styled from "@emotion/styled";

import { Box, Flex } from "@/components/layout/flexbox";
import { Container } from "@/components/pieces/bootstrap";
import QuoteGrid from "@/components/pieces/marketing/QuoteGrid";
import { StyledTitle } from "@/components/pieces/marketing/Titles";
import LPLink from "@/components/pieces/upsell/LPLink";
import {
  BRAND_PURPLE,
  PURPLE_TEXT_COLOR,
  SUBTEXT_COLOR,
} from "@/css/constants";

export const DEFAULT_QUOTES = [
  {
    specialtySlug: "life-coaching",
    quote:
      "With my coach, I developed more sustainable ways to grow at a point in my life where I felt like I was stagnating. Thank you Placement!",
    authorName: "David",
    location: "Boise, ID",
    avatarConfig: {
      sex: "man",
      faceColor: "#F9C9B6",
      earSize: "big",
      eyeStyle: "oval",
      noseStyle: "long",
      mouthStyle: "smile",
      shirtStyle: "polo",
      glassesStyle: "round",
      hairColor: "#fff",
      hairStyle: "normal",
      hatStyle: "none",
      hatColor: "#D2EFF3",
      eyeBrowStyle: "up",
      shirtColor: "#9287FF",
      bgColor: "#FFEDEF",
    },
    products: ["placement", "exec"],
  },
  {
    specialtySlug: "leadership-coaching",
    quote:
      "My coaching sessions really help me improve my communication with my team. I feel more confident talking about areas of improvement and process changes.",
    authorName: "Natalie",
    location: "New York, NY",
    avatarConfig: {
      sex: "woman",
      faceColor: "#BF8F81",
      earSize: "small",
      eyeStyle: "smile",
      noseStyle: "long",
      mouthStyle: "laugh",
      shirtStyle: "hoody",
      glassesStyle: "none",
      hairColor: "#77311D",
      hairStyle: "womanLong",
      hatStyle: "none",
      hatColor: "#D2EFF3",
      eyeBrowStyle: "up",
      shirtColor: "#F4D150",
      bgColor: "#E0DDFF",
    },
    products: ["placement", "exec"],
  },
  {
    specialtySlug: "job-search-coaching",
    quote:
      "I am literally making just shy of DOUBLE my highest salary. I couldn't have done any of it without Placement. Again, I cannot say enough good things. You truly have a team behind you every step of the way, and MAN what a difference it makes.",
    authorName: "Sarah",
    location: "Oakland, CA",
    avatarConfig: {
      sex: "woman",
      faceColor: "#BF8F81",
      earSize: "small",
      eyeStyle: "smile",
      noseStyle: "short",
      mouthStyle: "peace",
      shirtStyle: "hoody",
      glassesStyle: "none",
      hairColor: "#000",
      hairStyle: "womanLong",
      hatStyle: "none",
      hatColor: "#D2EFF3",
      eyeBrowStyle: "up",
      shirtColor: "#9287FF",
      bgColor: "#D2EFF3",
    },
    products: ["placement", "exec"],
  },
  {
    specialtySlug: "life-coaching",
    quote:
      "Placement gave me back my confidence. They gave me the tools to believe in myself and show that confidence. I can't recommend them enough!",
    authorName: "Elizabeth",
    location: "Los Angeles, CA",
    avatarConfig: {
      sex: "woman",
      faceColor: "#F9C9B6",
      earSize: "big",
      eyeStyle: "smile",
      noseStyle: "short",
      mouthStyle: "laugh",
      shirtStyle: "polo",
      glassesStyle: "none",
      hairColor: "#77311D",
      hairStyle: "normal",
      hatStyle: "none",
      hatColor: "#fff",
      eyeBrowStyle: "upWoman",
      shirtColor: "#F4D150",
      bgColor: "#FFEDEF",
    },
    products: ["placement", "exec"],
  },
  {
    specialtySlug: "job-search-coaching",
    quote:
      "I had an incredible experience with Placement. The greatest benefit to me was in the coaching and support from my career coach. He provided the confidence and discipline that were needed to land ‘The One.’",
    authorName: "Patrick",
    location: "Nashville, TN",
    avatarConfig: {
      sex: "man",
      faceColor: "#F9C9B6",
      earSize: "big",
      eyeStyle: "oval",
      noseStyle: "long",
      mouthStyle: "peace",
      shirtStyle: "polo",
      glassesStyle: "square",
      hairColor: "#000",
      hairStyle: "thick",
      hatStyle: "none",
      hatColor: "#FC909F",
      eyeBrowStyle: "up",
      bgColor: "#E0DDFF",
    },
    products: ["placement", "exec"],
  },
  {
    specialtySlug: null,
    quote: `My coach can see the bigger picture and maintain a calm presence no matter how we show up. Her dedication to her craft is noticeable, and I am grateful that I've gotten to work with her.`,
    authorName: "Theo",
    location: "Los Angeles, CA",
    avatarConfig: {
      sex: "man",
      faceColor: "#F9C9B6",
      earSize: "big",
      eyeStyle: "smile",
      noseStyle: "long",
      mouthStyle: "laugh",
      shirtStyle: "short",
      glassesStyle: "none",
      hairColor: "#000",
      hairStyle: "thick",
      hatStyle: "none",
      hatColor: "#000",
      eyeBrowStyle: "up",
      shirtColor: "#9287FF",
      bgColor: "#D2EFF3",
    },
    products: ["placement", "exec"],
  },
  {
    specialtySlug: null,
    quote:
      "My coach came very prepared. We achieved more in 30 minutes that I would have in hours of trying to plan things on my own. I look forward to my next session.",
    authorName: "Claire",
    location: "Seattle, WA",
    avatarConfig: {
      sex: "woman",
      faceColor: "#F9C9B6",
      earSize: "big",
      eyeStyle: "oval",
      noseStyle: "short",
      mouthStyle: "smile",
      shirtStyle: "polo",
      glassesStyle: "none",
      hairColor: "#77311D",
      hairStyle: "womanLong",
      hatStyle: "none",
      hatColor: "#fff",
      eyeBrowStyle: "upWoman",
      shirtColor: "#F4D150",
      bgColor: "#D2EFF3",
    },
    products: ["placement", "exec"],
  },
  {
    specialtySlug: null,
    quote:
      "My coach was amazing at providing feedback with no judgment about my situation! I am really excited about the course we charted together.",
    authorName: "Tara",
    location: "Los Angeles, CA",
    avatarConfig: {
      sex: "woman",
      faceColor: "#AC6651",
      earSize: "small",
      eyeStyle: "smile",
      noseStyle: "short",
      mouthStyle: "peace",
      shirtStyle: "hoody",
      glassesStyle: "none",
      hairColor: "#000",
      hairStyle: "womanShort",
      hatStyle: "none",
      hatColor: "#D2EFF3",
      eyeBrowStyle: "up",
      shirtColor: "#9287FF",
      bgColor: "#FFEDEF",
    },
    products: ["placement", "exec"],
  },
  {
    specialtySlug: null,
    quote:
      "Working with my coach has been game-changing. He helps me establish priorities, develop an action plan, and continually hit my goals!",
    authorName: "Steven",
    location: "New York, NY",
    avatarConfig: {
      sex: "man",
      faceColor: "#BF8F81",
      earSize: "big",
      eyeStyle: "smile",
      noseStyle: "long",
      mouthStyle: "smile",
      shirtStyle: "hoody",
      glassesStyle: "none",
      hairColor: "#000",
      hairStyle: "thick",
      hatStyle: "none",
      hatColor: "#F48150",
      eyeBrowStyle: "up",
      shirtColor: "#F4D150",
      bgColor: "#E0DDFF",
    },
    products: ["placement", "exec"],
  },
  {
    specialtySlug: "leadership-coaching",
    quote:
      "My coach has so much experience to draw on in terms of leadership, influence, and process. I am able to leverage her experinece in handling my work. She asks the right questions at the right time to ensure my decisions are on track.",
    authorName: "Susan",
    location: "Nashville, TN",
    avatarConfig: {
      sex: "woman",
      faceColor: "#F9C9B6",
      earSize: "big",
      eyeStyle: "small",
      noseStyle: "long",
      mouthStyle: "peace",
      shirtStyle: "polo",
      glassesStyle: "none",
      hairColor: "#000",
      hairStyle: "womanLong",
      hatStyle: "none",
      hatColor: "#FC909F",
      eyeBrowStyle: "up",
      bgColor: "#E0DDFF",
    },
    products: ["placement", "exec"],
  },
  {
    specialtySlug: "career-coaching",
    quote: `Placement matched me with an amazing coach. I'm sure they could make any client better! I have renewed larity of purpose and boundaries and my coach helps me take the best next step.`,
    authorName: "Irene",
    location: "Miami, FL",
    avatarConfig: {
      sex: "woman",
      faceColor: "#F9C9B6",
      earSize: "big",
      eyeStyle: "smile",
      noseStyle: "short",
      mouthStyle: "smile",
      shirtStyle: "short",
      shirtColor: "#6BD9E9",
      glassesStyle: "none",
      hairColor: "#77311D",
      hairStyle: "womanShort",
      hatStyle: "none",
      hatColor: "#FC909F",
      eyeBrowStyle: "up",
      bgColor: "#E0DDFF",
    },
    products: ["placement", "exec"],
  },
  {
    specialtySlug: "career-coaching",
    quote:
      "My coach is very kind, personable and knowledgeable. He shares very valuable feedback on how I can navigate my career development",
    authorName: "Carlos",
    location: "New York, NY",
    avatarConfig: {
      sex: "man",
      faceColor: "#F9C9B6",
      earSize: "small",
      eyeStyle: "circle",
      noseStyle: "long",
      mouthStyle: "peace",
      shirtStyle: "hoody",
      glassesStyle: "none",
      hairColor: "#000",
      hairStyle: "womanLong",
      hatStyle: "beanie",
      hatColor: "#FC909F",
      eyeBrowStyle: "up",
      bgColor: "#D2EFF3",
    },
    products: ["placement", "exec"],
  },
] as Testimonial[];

interface AvatarConfig {
  sex: "man" | "woman";
  faceColor: string;
  earSize: "big" | "small";
  eyeStyle: "oval" | "smile" | "small" | "circle";
  noseStyle: "long" | "short";
  mouthStyle: "smile" | "laugh" | "peace";
  shirtStyle: "polo" | "hoody" | "short";
  glassesStyle: "round" | "square" | "none";
  hairColor: string;
  hairStyle: "normal" | "thick" | "womanLong" | "womanShort";
  hatStyle: "none" | "beanie";
  hatColor: string;
  eyeBrowStyle: "up" | "upWoman";
  shirtColor?: string;
  bgColor: string;
}

export interface Testimonial {
  specialtySlug?:
    | "life-coaching"
    | "leadership-coaching"
    | "job-search-coaching"
    | "career-coaching";
  quote: string;
  authorName: string;
  location: string;
  avatarConfig: AvatarConfig;
  products: string[];
  noPhoto?: boolean;
  type?: string;
  authorPhoto?: string;
}

interface TestimonialsProps {
  buttonLink?: string;
  buttonText?: string;
  pricingIntro?: ReactNode;
  specialtySlug?: string;
  headline?: string;
  testimonials?: Testimonial[];
  buttonOpts?: Record<string, unknown>;
  limit?: number;
  header?: ReactNode;
  onCtaClick?: () => void;
  backgroundColor?: string;
}

export default function Testimonials({
  buttonLink,
  buttonText,
  pricingIntro,
  specialtySlug,
  headline = "What Others Are Saying",
  testimonials = DEFAULT_QUOTES,
  buttonOpts,
  limit = 9,
  header,
  onCtaClick,
  backgroundColor = "#FFF",
}: TestimonialsProps) {
  const btnOpts = {
    to:
      buttonLink ||
      `/match/${specialtySlug}?type=find%20my%20agent%20button&source=${encodeURIComponent(
        "pro page",
      )}`,
    py: 1,
    fontSize: 20,
    width: 295,
    ...buttonOpts,
  };

  if (!buttonText && !pricingIntro && (!testimonials || !testimonials.length))
    return null;
  const domain = IS_EXEC ? "exec" : "placement";
  const fTestimonials = testimonials
    .filter(
      (t) =>
        (!specialtySlug ||
          !t.specialtySlug ||
          t.specialtySlug === specialtySlug) &&
        t.products.includes(domain),
    )
    .slice(0, limit);

  return (
    <Box py={80} backgroundColor={backgroundColor}>
      {fTestimonials && fTestimonials.length ? (
        <Container>
          {header ? (
            header
          ) : (
            <StyledTitle color={PURPLE_TEXT_COLOR}>{headline}</StyledTitle>
          )}
          <QuoteGrid quotes={fTestimonials} />
        </Container>
      ) : null}
      {(buttonText || pricingIntro) && (
        <Flex alignItems="center" flexDirection="column" mt={2} pt={4}>
          {buttonText && (
            <Box mb={3}>
              <LPLink
                onCtaClick={onCtaClick}
                to={btnOpts.to}
                color={BRAND_PURPLE}
                text={buttonText}
                style={{
                  py: btnOpts.py,
                  fontSize: btnOpts.fontSize,
                  width: btnOpts.width,
                }}
              />
            </Box>
          )}
          {pricingIntro ? (
            <Box>
              <DetailText>{pricingIntro}</DetailText>
            </Box>
          ) : null}
        </Flex>
      )}
    </Box>
  );
}

const DetailText = styled("div")`
  font-size: 18px;
  color: ${SUBTEXT_COLOR};
`;
